module.exports = __webpack_public_path__ + "static/media/012.4b3229ab.jpg";